import { environment, firebaseApp } from "./env";

import Clarity from "@microsoft/clarity";
import { isRedactiveUser } from "./helpers";
import { getAnalytics, logEvent, setUserId, setUserProperties, type Analytics } from "firebase/analytics";
import type { UserInfo } from "firebase/auth";

let analytics: Analytics;

export const initAnalytics = async () => {
  const env = await environment;

  analytics = await getAnalytics(await firebaseApp);
  console.debug("[tracking] initAnalytics for GA", analytics);
  Clarity.init(env.analytics.clarityProjectId);
  console.debug("[tracking] initAnalytics for Clarity", Clarity);
};

export const setAnalyticsIdentity = async (userInfo: UserInfo, sessionId: string, pageId: string, orgId?: string) => {
  const redactiveUser = !!(await isRedactiveUser(userInfo?.email ?? ""));
  if (analytics) {
    setUserId(analytics, userInfo.uid);
    setUserProperties(analytics, {
      session_id: sessionId,
      page_id: pageId,
      org_id: orgId,
      is_redactive_user: redactiveUser,
    });
    console.debug("[tracking] setAnalyticsIdentity for GA", userInfo.uid, sessionId, pageId, orgId, redactiveUser);
  }

  Clarity.identify(userInfo.uid, sessionId, pageId);

  /**
   * These tag will be stay for the duration of the session.
   */
  if (orgId) {
    Clarity.setTag("orgId", orgId);
  }
  Clarity.setTag("isRedactiveUser", redactiveUser.toString());

  console.debug("[tracking] setAnalyticsIdentity for Clarity", userInfo.uid, sessionId, pageId, orgId, redactiveUser);
};

export async function logAnalyticsEvent(eventName: string, properties?: Record<string, string>) {
  if (analytics) {
    logEvent(analytics, eventName, properties);
    console.debug("[tracking] logAnalyticsEvent for GA", eventName, properties);
  }

  /**
   * Clarity event does not support properties.
   * We need to use setTag to set the properties.
   * This tag will be stay for the duration of the session.
   */
  Clarity.event(eventName);

  if (properties) {
    // This tag will be stay for the duration of the session
    Object.entries(properties).forEach(([key, value]) => {
      if (value !== undefined) {
        Clarity.setTag(key, value);
      }
    });
  }

  console.debug("[tracking] logAnalyticsEvent for Clarity", eventName, properties);
}
